<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import moment from "moment";
import { urlMethods } from "@/state/helpers";

export default {
  page: {
    title: "Thu hồi COD",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner,
  },
  data() {
    return {
      title: "Thu hồi COD",
      soName: "",
      oldSoName: "",
      products: [],
      order: false,
      reason: false,
      isDisabled: false,
      isDisabledButton: false,
      discount: 0,
      netSale: 0,
      warehouse: { id: 0, name: "" },
      note: "",
      isLoading: false,
      listOrder: [],
      draftWarning: null,
      doPayment: false,
      paymentMethod: null,
      listPaymentMethods: [],
      listReasons: [
        { id: 1, name: "Giao nhầm sản phẩm" },
        { id: 2, name: "Khách đổi hình thức thanh toán" },
        { id: 3, name: "Khách đổi mẫu" },
        { id: 4, name: "Khách hết nhu cầu" },
        { id: 5, name: "Sai chính sách" },
        { id: 6, name: "Thiếu quà tặng" },
        { id: 7, name: "Trùng đơn" },
      ],
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem("currentUser") || false;
      return user ? JSON.parse(user) : false;
    },
    validateForm() {
      if (this.products.length < 1) return false;
      if (this.soName.length < 5) return false;
      if (
        !this.reason ||
        typeof this.reason.id == "undefined" ||
        this.reason.id < 1
      )
        return false;
      return true;
    },
    grossSale() {
      let total = 0;
      for (const item of this.products) {
        let item_total =
          parseFloat(item.price_unit) -
          (parseFloat(item.price_unit) * parseFloat(item.discount)) / 100;
        total += item_total;
      }
      total = Math.round(total);
      return total.toLocaleString();
    },
  },
  methods: {
    ...urlMethods,
    formatMoney(input) {
      if (
        typeof input == "undefined" ||
        input == null ||
        !input ||
        isNaN(input)
      )
        return 0;
      return input.toLocaleString();
    },
    async getWarehouse() {
      let that = this;
      try {
        let res = await that.getUrl("warehouse");
        that.warehouse = res.data;
      } catch (error) {}
    },
    async getPaymentMethods() {
      try {
        let res = await this.getUrl("hbpos/payment-methods");
        this.listPaymentMethods = res.data || [];
      } catch (error) {}
    },
    removeItem(product_id, lot_name) {
      lot_name = lot_name == null ? "" : lot_name;
      product_id = product_id == null ? "" : product_id;
      this.products = this.products.filter(function(item) {
        if (lot_name == "") {
          return item.product_id != product_id ? item : false;
        }
        return item.lot_name != lot_name ? item : false;
      });
    },
    price_total(item) {
      return Math.round(
        item.price_unit - (item.price_unit * item.discount) / 100,
        0
      );
    },
    async saveOrder() {
      let that = this;
      if (this.soName.length < 5) {
        that.$store.dispatch("sale/setNoti", {
          text: "Chưa có thông tin đơn hàng thu hồi",
          type: "error",
        });
        return false;
      }
      if (this.products.length < 1) {
        that.$store.dispatch("sale/setNoti", {
          text: "Chưa có thông tin sản phẩm thu hồi",
          type: "error",
        });
        return false;
      }
      if (
        !this.reason ||
        typeof this.reason.id == "undefined" ||
        this.reason.id < 1
      ) {
        that.$store.dispatch("sale/setNoti", {
          text: "Chưa chọn lý do thu hồi",
          type: "error",
        });
        return false;
      }
      if (!that.validateForm) {
        that.$store.dispatch("sale/setNoti", {
          text: "Vui lòng điền đầy đủ thông tin trước khi tạo đơn",
          type: "error",
        });
        return false;
      }
      if (this.grossSale < 0) {
        that.$store.dispatch("sale/setNoti", {
          text: "Bạn không thể thu hồi đơn hàng số tiền < 0₫",
          type: "error",
        });
        return false;
      }
      let totalAmount = 0;
      for (const item of that.products) {
        totalAmount += parseFloat(item.price_unit) - (parseFloat(item.price_unit) * parseFloat(item.discount)) / 100;
      }
      totalAmount = Math.round(totalAmount);
      let body = {
        order_id: that.order.id,
        partner_id: that.order.partner_id,
        revoke_id: that.reason.id,
        lines: that.products,
        saler: that.order.saler,
        location_id: that.warehouse.id,
        note: that.note,
        totalAmount: totalAmount,
        payment_method_id: that.paymentMethod ? that.paymentMethod.id : null,
      };
      that.isLoading = true;
      that.isDisabledButton = true;
      setTimeout(async () => {
        try {
          let res = await that.postUrl({ url: "hbcod/add", data: body });
          if (typeof res.error != "undefined" && res.error) throw res.message;
          that.$router.push(`/hbcod/${res.data}`);
          that.isLoading = false;
        } catch (error) {
          that.isLoading = false;
          that.isDisabledButton = false;
          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        }
      }, 100);
    },
    async setOrder(item) {
      let that = this;

      if (item.sale_return_id) {
        this.$bvModal.hide("modal-search-order");
        that.draftWarning = { id: item.sale_return_id, name: item.sale_return_name };
        return;
      }
      that.draftWarning = null;

      that.isLoading = true;
      that.oldSoName = item.name;
      that.soName = item.name;
      setTimeout(async () => {
        try {
          let res = await that.postUrl({
            url: "hbcod/lines-order",
            data: { id: item.id },
          });
          that.isLoading = false;
          this.$bvModal.hide("modal-search-order");
          if (
            typeof res.data == "undefined" ||
            typeof res.data[0] == "undefined"
          ) {
            throw "Đơn hàng không khả dụng để thu hồi. Vui lòng kiểm tra lại";
          }
          that.order = res.data[0];
          that.products = res.data;
        } catch (error) {
          that.isLoading = false;
          this.$bvModal.hide("modal-search-order");
          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        }
      }, 50);
    },
    async searchOrder() {
      let that = this;
      that.soName = that.soName.replace(/ /g, "");
      if (that.soName.length < 5) {
        return false;
      }
      if (that.oldSoName == that.soName && that.products.length > 0)
        return false;
      that.oldSoName = that.soName;
      that.products = [];
      that.order = false;
      that.listOrder = [];
      that.draftWarning = null;
      that.isLoading = true;
      setTimeout(async () => {
        try {
          let res = await that.postUrl({
            url: "hbcod/search-order",
            data: { name: that.soName },
          });
          that.isLoading = false;
          if (
            typeof res.data == "undefined" ||
            typeof res.data[0] == "undefined"
          ) {
            throw "Không tìm thấy thông tin đơn hàng. Vui lòng kiểm tra lại";
          }
          if (res.data.length == 1) {
            that.setOrder(res.data[0]);
          } else {
            that.listOrder = res.data;
            this.$bvModal.show("modal-search-order");
          }
        } catch (error) {
          that.isLoading = false;

          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        }
      }, 50);
    },
  },
  mounted() {
    this.getWarehouse();
    this.getPaymentMethods();
  },
};
</script>

<template>
  <Layout>
    <div class="page-header mb-3">
      <div class="page-title">
        <h4 class="mb-0 font-size-18">THU HỒI ĐƠN COD</h4>
      </div>
    </div>
    <div
      v-if="draftWarning"
      class="alert alert-warning alert-dismissible"
      role="alert"
    >
      <button type="button" class="close" @click.stop="draftWarning = null">
        <span>&times;</span>
      </button>
      <i class="fa fa-exclamation-triangle mr-1"></i>
      Đơn hàng đã có phiếu thu hồi nháp <strong>{{ draftWarning.name }}</strong>.
      <a :href="'https://one.tga.com.vn/so/returns/detail/' + draftWarning.id" target="_blank">Click vào đây để chuyển tới trang thu hồi HBCOD nháp</a>
    </div>
    <div class="card">
      <div class="card-body p-2">
        <div class="row mb-2">
          <!-- Cột trái -->
          <div class="col-md-6 mb-0">
            <div class="card p-0 mb-0">
              <div class="card-body p-0 mb-0" style="background: white;">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th width="140px" valign="middle">Mã đơn hàng</th>
                      <td scope="row" class="has-input">
                        <div class="flex-box">
                          <div class="flex-full mr-2">
                            <b-form-input
                              @keyup.enter="searchOrder"
                              ref="soName"
                              autocomplete="off"
                              for="soName"
                              v-model="soName"
                            ></b-form-input>
                          </div>
                          <button
                            type="button"
                            class="btn btn-primary btn-search"
                            @click="searchOrder"
                          >
                            <i class="bx bx-search-alt search-icon"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Khách hàng</th>
                      <td scope="row">
                        {{ order.customer_name ? order.customer_name + " - " + order.customer_phone : "" }}
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Ngày bán hàng</th>
                      <td scope="row">{{ order.create_date || "" }}</td>
                    </tr>
                    <tr>
                      <th valign="middle">NVBH</th>
                      <td scope="row">{{ order.saler || "" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- Cột phải -->
          <div class="col-md-6 mb-0">
            <div class="card p-0 mb-0">
              <div class="card-body p-0 mb-0" style="background: white;">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th width="140px" valign="middle">Kho thu hồi</th>
                      <td scope="row">{{ warehouse.name || "" }}</td>
                    </tr>
                    <tr>
                      <th valign="middle">Lý do thu hồi</th>
                      <td scope="row" class="has-input">
                        <multiselect
                          track-by="id"
                          label="name"
                          v-model="reason"
                          :options="listReasons"
                          placeholder="Chọn lý do thu hồi"
                          :allow-empty="false"
                          :show-labels="false"
                        ></multiselect>
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Thanh toán HĐ</th>
                      <td scope="row">
                        <switches
                          v-model="doPayment"
                          @input="val => { if (!val) paymentMethod = null }"
                          color="success"
                          :emit-on-mount="false"
                        ></switches>
                      </td>
                    </tr>
                    <tr v-if="doPayment">
                      <th valign="middle">Phương thức TT</th>
                      <td scope="row" class="has-input">
                        <div style="position: relative;">
                          <multiselect
                            track-by="id"
                            label="name"
                            v-model="paymentMethod"
                            :options="listPaymentMethods"
                            placeholder="Chọn phương thức thanh toán"
                            :allow-empty="true"
                            :show-labels="false"
                          ></multiselect>
                          <button
                            v-if="paymentMethod"
                            @click="paymentMethod = null"
                            type="button"
                            style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: none; border: none; padding: 0; line-height: 1; color: #999; font-size: 16px; cursor: pointer; z-index: 10;"
                          >&#x2715;</button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Ghi chú</th>
                      <td scope="row" class="has-input">
                        <b-form-input
                          autocomplete="off"
                          v-model="note"
                        ></b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs
        content-class="p-2"
        nav-wrapper-class="nav-item"
        class="p-0"
        nav-class="nav-tabs-custom"
        v-if="products.length > 0"
      >
        <b-tab title="Sản phẩm" active>
          <div class="table-responsive" style="padding: 0px">
            <table class="table table-striped table-bordered mb-0">
              <thead>
                <tr>
                  <th>Serial</th>
                  <th>Sản phẩm</th>
                  <!-- <th>Số lượng</th> -->
                  <th>Đơn giá</th>
                  <th>Giảm giá (%)</th>
                  <th>Tổng tiền</th>
                  <th><i class="fa fa-cogs"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in products" :key="index">
                  <td>{{ item.lot_name || '_' }}</td>
                  <td>{{ item.product_name }}</td>
                  <!-- <td class="has-input">{{ item.quantity }}</td> -->
                  <td class="has-input">
                    <money
                      class="form-control text-right"
                      autocomplete="off"
                      v-model="item.price_unit"
                    ></money>
                  </td>
                  <td class="has-input">
                    <money
                      class="form-control text-right"
                      autocomplete="off"
                      v-model="item.discount"
                    ></money>
                  </td>
                  <td class="text-right">
                    {{ formatMoney(price_total(item)) }}
                  </td>
                  <td class="has-input">
                    <button
                      @click="removeItem(item.product_id, item.lot_name)"
                      class="btn btn-danger btn-sm"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-right pt-3 font-size-18">
            <b>THÀNH TIỀN: {{ grossSale }} <sup>₫</sup></b>
          </div>
        </b-tab>
      </b-tabs>
      <div class="text-right p-3" v-if="products.length > 0">
        <button
          @click="saveOrder"
          type="button"
          class="btn btn-primary"
          :disabled="isDisabledButton"
        >
          Tạo đơn
        </button>
      </div>
    </div>

    <b-modal
      id="modal-search-order"
      title="Chọn đơn bán hàng"
      size="lg"
      title-class="font-18"
      hide-footer
    >
      <div class="table-responsive" style="padding: 0px">
        <table class="table table-striped table-bordered mb-0">
          <thead>
            <tr>
              <th>Mã đơn</th>
              <th>Ngày bán</th>
              <th>Khách hàng</th>
              <th>Tổng tiền</th>
              <th><i class="fa fa-cogs"></i></th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="cursor:pointer"
              v-for="(item, index) in listOrder"
              :key="index"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.create_date }}</td>
              <td>{{ item.customer_name }}</td>
              <td>{{ parseFloat(item.amount_total).toLocaleString() }}</td>
              <td>
                <button
                  @click="setOrder(item)"
                  type="button"
                  class="btn btn-sm btn-primary"
                >
                  Thu hồi
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <div :class="isLoading ? 'flex-middle-full loading-full' : 'hidden'">
      <i class="fas fa-spinner fa-spin font-size-34"></i>
    </div>
  </Layout>
</template>

<style>
.vue-switcher {
  margin-bottom: 0 !important;
}
.vue-switcher--unchecked div {
  background-color: #adb5bd !important;
}
.vue-switcher--unchecked div::after {
  background-color: #fff !important;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) !important;
}
</style>
